// libs/react-mosaic-component/src/lib/buttons/MosaicButton.tsx
import classNames from "classnames";
import React from "react";
import { MosaicContext } from "../contextTypes.mjs";
import { OptionalBlueprint } from "../util/OptionalBlueprint.mjs";
var DefaultToolbarButton = ({
  title,
  className,
  onClick,
  text
}) => {
  const { blueprintNamespace } = React.useContext(MosaicContext);
  return /* @__PURE__ */ React.createElement(
    "button",
    {
      title,
      onClick,
      className: classNames(
        "mosaic-default-control",
        OptionalBlueprint.getClasses(blueprintNamespace, "BUTTON", "MINIMAL", "SMALL"),
        className
      )
    },
    text && /* @__PURE__ */ React.createElement("span", { className: "control-text" }, text)
  );
};
var createDefaultToolbarButton = (title, className, onClick, text) => /* @__PURE__ */ React.createElement(
  DefaultToolbarButton,
  {
    title,
    className,
    onClick,
    text
  }
);
export {
  DefaultToolbarButton,
  createDefaultToolbarButton
};
